import { render } from "./RolesDrawer.vue?vue&type=template&id=23b18b2f&scoped=true"
import script from "./RolesDrawer.vue?vue&type=script&lang=js"
export * from "./RolesDrawer.vue?vue&type=script&lang=js"

import "./RolesDrawer.vue?vue&type=style&index=0&id=23b18b2f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b18b2f"]])

export default __exports__